import { Chip, Divider, List, ListItem, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import {
  spacing,
  typography,
  colors,
} from "../../../../../../../../../assets/styles/tokens";

interface BudgetControlGraphMoreMetricsProps {
  qftd: string;
  qftd_status: string;
  qftd_percentage: string;

  rr_budget_status: string;
  rr_budget_percentage: string;

  remaining_qftd: string;
  cpa_income_dollar: string;
  total_income_dollar: string;
  cpa_budget_dollar: string;
  ftd: string;
}

const BudgetControlGraphMoreMetrics = ({
  qftd,
  qftd_status,
  qftd_percentage,

  rr_budget_status,
  rr_budget_percentage,

  remaining_qftd,
  cpa_income_dollar,
  total_income_dollar,
  cpa_budget_dollar,
  ftd,
}: BudgetControlGraphMoreMetricsProps) => {
  return (
    <>
      <Stack>
        <List sx={{ pb: 0, color: colors.GrayLightMode[900].$value }}>
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
                alignItems:'center'
              }}
            >
              QFTD
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                   alignItems:'center'
                }}
              >
                {qftd}
                <Chip
                  label={qftd_percentage}
                  size="small"
                  sx={{
                    borderRadius: spacing.Radius.xs.$value,
                    fontSize: typography.Size.Text.xs.$value,
                    ml: spacing.Spacing.sm.$value,
                    bgcolor:
                      qftd_status === "success"
                        ? colors.Success[50].$value
                        : qftd_status === "warning"
                          ? colors.Warning[50].$value
                          : colors.Error[50].$value,

                    color:
                      qftd_status === "success"
                        ? colors.Success[600].$value
                        : qftd_status === "warning"
                          ? colors.Warning[600].$value
                          : colors.Error[600].$value,

                    fontWeight: typography.Font_weight.Semibold.$value,
                  }}
                />
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
                 alignItems:'center'
              }}
            >
              RR BUDGET USED
              <Chip
                label={rr_budget_percentage}
                size="small"
                sx={{
                  borderRadius: spacing.Radius.xs.$value,
                  fontSize: typography.Size.Text.xs.$value,
                  bgcolor:
                    rr_budget_status === "success"
                      ? colors.Success[50].$value
                      : rr_budget_status === "warning"
                        ? colors.Warning[50].$value
                        : colors.Error[50].$value,

                  color:
                    rr_budget_status === "success"
                      ? colors.Success[600].$value
                      : rr_budget_status === "warning"
                        ? colors.Warning[600].$value
                        : colors.Error[600].$value,

                  fontWeight: typography.Font_weight.Semibold.$value,
                }}
              />
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              REMAINING QFTD
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {remaining_qftd}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              CPA INCOME
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {cpa_income_dollar}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              TOTAL INCOME
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {total_income_dollar}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              CPA BUDGET
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {cpa_budget_dollar}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              FTD
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {ftd}
              </Box>
            </Typography>
          </ListItem>
        </List>
      </Stack>
    </>
  );
};

export default BudgetControlGraphMoreMetrics;
